<template>
  <header
    class="page-designer-header"
    :class="{
      '--sticky': stickyColumn,
    }"
  >
    <div class="page-designer-header__column" ref="text">
      <!-- Titolo  -->
      <h1 data-animate="header-title" class="title-m">
        {{ designer.title }}
      </h1>

      <!-- Description  -->
      <div
        v-if="designer.designerDescription"
        data-animate="header-content"
        class="text-l m-top-6 --large"
        v-html="designer.designerDescription"
      />
    </div>

    <div class="page-designer-header__column" ref="image">
      <div class="page-designer-header__image" data-animate="header-image">
        <WidgetPicture
          v-if="designer?.designerImage?.[0]"
          :image="{
            custom: designer.designerImage[0],
          }"
          :alt="designer.designerImage[0].title"
        />
      </div>

      <!-- Description  -->
      <div
        class="m-top-3 --small"
        aria-hidden="true"
        v-if="designer.designerDescription"
      >
        <div
          data-animate="header-content"
          class="text-l m-top-6"
          v-html="designer.designerDescription"
        />
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'PagesDesignerHeader',
}
</script>

<script setup>
import { debounce } from '~/assets/js/utils.js'

const props = defineProps({
  designer: Object,
})

const text = ref(null)
const image = ref(null)

const stickyColumn = ref(false)

onMounted(() => {
  setTimeout(() => compareColumns(), 250)

  window.addEventListener('resize', debounce(compareColumns))
})

// Function to compare column dimensions
const compareColumns = () => {
  if (text.value && image.value) {
    const height1 = text?.value?.offsetHeight
    const height2 = image?.value?.offsetHeight

    if (height1 > height2) {
      stickyColumn.value = true
    } else {
      stickyColumn.value = false
    }
  }
}
</script>

<style lang="scss">
@import './style.scss';
</style>
